/**
 * Loading skeleton placeholders for STM32 suite (tree, list, button).
 * Single component for consistent look; use variant for context.
 */

import React from 'react';

/**
 * @param {string} variant - 'tree' | 'list' | 'button' | 'line'
 */
export default function Skeleton({ variant = 'line', className = '' }) {
  const base = 'animate-pulse bg-gray-800 rounded';

  if (variant === 'tree') {
    return (
      <div className={`space-y-3 ${className}`} aria-hidden>
        <div className={`h-6 ${base} w-3/4`} />
        <div className="ml-4 space-y-2">
          <div className={`h-5 ${base} w-1/2`} />
          <div className={`h-5 ${base} w-2/3`} />
          <div className={`h-5 ${base} w-1/3`} />
        </div>
        <div className={`h-6 ${base} w-2/3`} />
        <div className="ml-4 space-y-2">
          <div className={`h-5 ${base} w-full`} />
          <div className={`h-5 ${base} w-4/5`} />
          <div className={`h-5 ${base} w-3/5`} />
        </div>
        <div className={`h-6 ${base} w-1/2`} />
        <div className="ml-4">
          <div className={`h-5 ${base} w-2/5`} />
        </div>
      </div>
    );
  }

  if (variant === 'list') {
    return (
      <div className={`space-y-1 ${className}`} aria-hidden>
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div key={i} className={`h-10 ${base} w-full`} style={{ animationDelay: `${i * 50}ms` }} />
        ))}
      </div>
    );
  }

  if (variant === 'button') {
    return (
      <div className={`h-12 ${base} w-56 ${className}`} aria-hidden />
    );
  }

  return <div className={`h-4 ${base} w-full ${className}`} aria-hidden />;
}
